import api from '.'

export const queries = {
  create (trialId, data, success, fail) {
    api.authenticatedRequest('POST', `/trials/${trialId}/queries`, data, success, fail)
  },
  getForTrial (trialId, success, fail) {
    api.authenticatedRequest('GET', `/trials/${trialId}/queries`, null, success, fail)
  },
  update (queryId, data, success, fail) {
    api.authenticatedRequest('PUT', `/queries/${queryId}`, data, success, fail)
  },
  delete (queryId, success, fail) {
    api.authenticatedRequest('DELETE', `/queries/${queryId}`, null, success, fail)
  }
}
